import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CadastroHelprevService } from './service/cadastro-helprev.service';
import { take } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CadastroHelprev } from './model/cadastro-helprev';
import Swal from 'sweetalert2';
import { CaptchaComponent } from './captcha/captcha.component';
import { FileUploadComponent } from './file-upload/file-upload.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

}
